export const EXTERNAL_PASSPORT_APP_DOMAIN_NAME = 'carrierlogistics';
